/**
 * upgradePlanModalContainer.tsx
 */
import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

interface Props {
  top: number;
}

const UpgradePlanModalContainer = styled.div<Props>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: fixed;
  text-align: center;
  top: ${(props) => props.top * Screen.widthRatio}px;
  width: ${1920 * Screen.widthRatio}px;
`;

export default UpgradePlanModalContainer;
